let yo = require("yo-yo");
let csjs = require('csjs');
let insertCss = require('insert-css');
import notice from './notice-style.cs';

insertCss(csjs.getCss(notice));

export default class NoticePopup {

	constructor (mainCategory, categoryName = '') {
		this.mainCategory = mainCategory;
		this.name = categoryName;
		this.subscribeCallback = [];
		this.closeCallback = [];
		this.template = this.getTemplate();
		document.body.appendChild(this.template);
		this.hide();

		return this;
	}

	getTemplate() {
		return yo`
		<div class="${notice['notify-popup-wrapper']}">
			<div class="${notice['notify-popup-title']}">ให้เราแจ้งคุณเมื่อมีบทความมาใหม่</div>
			<div class="${notice['notify-popup-desc']}">กดติดตามบทความหมวด <span class="main-cat-txt">${this.name}</span> ที่นี่</div>
			<a href="#" class="dekdbutton clickt0-subscribe ${notice.dekdbutton}" onclick=${(e) => {this.subscribe(e)}}><i class=" fa icon-fa-bell"></i> ติดตาม</a>
			<i class="${notice['close-button']}" onclick=${() => {this.close()}}></i>
			<div class="${notice['notify-popup-more-container']}">
				<a class="${notice['notify-popup-more']}" href="https://goo.gl/8h8QRh" target="_blank" title="อ่านรายละเอียดเการแจ้งเตือนพิ่มเติม">อ่านรายละเอียดเพิ่มเติม <i class="icon-fa-angle-right"></i></a>
			</div>
		</div>
		`;
	}

	subscribe(e) {
		e.preventDefault();
		//console.log`clicked on subscribe ${this.name}`;
		for(let callback of this.subscribeCallback) {
			callback(this, e);
		}
	}

	close() {
		//console.log('popup - close');
		for(let callback of this.closeCallback) {
			callback(this);
		}
		this.template.classList.remove(notice.show);
		this.template.classList.add(notice.close);
	}

	show() {
		//console.log('popup - show');
		this.template.classList.add(notice.show);
		this.template.classList.remove(notice.hide);
		this.template.classList.remove(notice.close);
	}

	hide() {
		//console.log('popup - hide');
		this.template.classList.remove(notice.show);
		this.template.classList.add(notice.hide);
	}

	onSubscribeClicked(callback) {
		this.subscribeCallback.push(callback);
	}

	onCloseClicked(callback) {
		this.closeCallback.push(callback);
	}

	setCategoryName (name) {
		this.name = name;
		yo.update(this.template, this.getTemplate());
	}

}

require('insert-css')(csjs.getCss(notice));




/** WEBPACK FOOTER **
 ** ./main/assets/article/js/src/popup-subscribe.js
 **/